import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspection from "./component";

const mapStateToProps = ({
    user: { isSSRError }
}) => ({
    isSSRError
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspection);
